import useCheckWindowSize from "./useCheckWindowSize";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useIsMobile = () => useCheckWindowSize();

export default useIsMobile;
